import type { DatePanelStepDirection } from "web_myplann/Shared/Components/FlatRow/datePanelHelpers";
import { isYearWithinBounds } from "web_myplann/Shared/Components/FlatRow/isYearWithinBounds";

export const isYearStepEnabled = (
	year: number,
	direction: DatePanelStepDirection,
	minDate?: Date,
	maxDate?: Date,
): boolean => isYearWithinBounds(year + direction, minDate, maxDate);
